import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import debounce from 'lodash/debounce';
import flowRight from 'lodash/flowRight';
import * as CONSTANTS from '../constants';
import MATCHING_PROFILE_TEXT from './text';
import { post } from '../utils/apiUtils';
import withUser from '../utils/withUser';
import * as UTILS from '../utils/utilFunctions';
import MatchingProfilesTable from './MatchingProfilesTable';

class MatchingProfiles extends PureComponent {
  constructor(props) {
    super(props);
    this.getMatchingProfiles = this.getMatchingProfiles.bind(this);

    this.state = {
      candidates: [],
      loading: false
    };
    this.handleOnChangeSearch = flowRight(
      debounce(this.handleOnChangeSearch, 500),
      e => e.persist() || e
    );
  }

  getMatchingProfiles = (nameQuery, projectId) => {
    this.setState({ loading: true });
    this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: true });

    post(CONSTANTS.getMatchingProfilesByProjectIdURL, {
      nameQuery,
      projectId
    })
      .then(responseBody => {
        if (responseBody) {
          this.setState({ candidates: responseBody });
        }
      })
      .catch(() => {
        this.props.handleSnackbarOpen(MATCHING_PROFILE_TEXT.matchingProfiles.error.loadingError);
      })
      .finally(() => {
        this.setState({ loading: false });
        this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });
      });
  };

  /**
   *
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  handleOnChangeSearch = e => {
    const queryString = e.target.value;
    const projectIdFromParams = UTILS.getURLParam(this.props.history, 'pid');

    if (queryString || queryString === '') {
      this.getMatchingProfiles(e.target.value, projectIdFromParams);
    }
  };

  handleOnClickCandidate = id => {
    this.props.history.push(`/candidates?id=${id}`);
  };

  componentDidMount() {
    document.title = `Matchingprofile mit Kandidateneingang - ${UTILS.getTitle()}`;
    const projectIdFromParams = UTILS.getURLParam(this.props.history, 'pid');
    this.getMatchingProfiles('', projectIdFromParams);
  }

  render() {
    return (
      <div className="container-fluid d-flex flex-column">
        <div className="m-3 w-full d-flex flex-column align-items-center">
          <TextField
            style={{ width: '400px' }}
            disabled={this.state.loading}
            onChange={this.handleOnChangeSearch}
            placeholder={MATCHING_PROFILE_TEXT.searchField.placeHolder}
            variant="outlined"
          />
        </div>
        <MatchingProfilesTable candidateList={this.state.candidates || []} onCandidateClick={this.handleOnClickCandidate} />
      </div>
    );
  }
}

MatchingProfiles.propTypes = {
  liftUpStateToApp: PropTypes.func.isRequired,
  handleSnackbarOpen: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired
};

export default withUser(MatchingProfiles);
